import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

interface IProps {
  prodUrl: (value: string) => string;
  catUrl: (value: string) => string;
}

const MobileBathFragranceSection = ({ prodUrl, catUrl }: IProps): ReactElement => {
  const { t: tMobile } = useTranslation('', {
    keyPrefix: '$pages.$home.$mobileHomePage.$bathFragranceSection',
  });

  return (
    <section className="mobile-bath-fragrance">
      <h2
        className="heading-flexbox"
        dangerouslySetInnerHTML={{ __html: tMobile('fragranceTitle') }}
      />
      <Link href={prodUrl('microfiberRobe')} className="img-frame right">
        <h3 className="subtitle" dangerouslySetInnerHTML={{ __html: tMobile('bathProd1') }} />
        <img
          src="/statics/img/mobile/microfiber-robe.webp"
          alt={tMobile('microfiberRobeImageAlt')}
          width={667}
          height={360}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
        />
      </Link>
      <Link href={prodUrl('terryRobe')} className="img-frame left">
        <h3 className="subtitle" dangerouslySetInnerHTML={{ __html: tMobile('bathProd2') }} />
        <img
          src="/statics/img/mobile/terry-robe.webp"
          alt={tMobile('terryRobeImageAlt')}
          width={667}
          height={360}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
        />
      </Link>
      <Link href={prodUrl('velvetSlippers')} className="img-frame right">
        <h3 className="subtitle" dangerouslySetInnerHTML={{ __html: tMobile('bathProd3') }} />
        <img
          src="/statics/img/mobile/velvet-slippers.webp"
          alt={tMobile('velvetSlippersImageAlt')}
          width={667}
          height={360}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
        />
      </Link>
      <Link href={catUrl('diagonalPiqueTowels')} className="img-frame">
        <h3 className="subtitle" dangerouslySetInnerHTML={{ __html: tMobile('bathProd4') }} />
        <img
          src="/statics/img/mobile/pique-towels.webp"
          alt={tMobile('piqueTowelsImageAlt')}
          width={667}
          height={360}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
        />
      </Link>
      <h3 className="subtitle frame">
        {tMobile('fragranceSubTitle')}
        <div className="connectors" />
        <div className="top-connector" />
      </h3>
      <div className="product-grid">
        <Link href={prodUrl('homeDiffuser')}>
          <img
            src="/statics/img/mobile/home-diffuser.webp"
            alt={tMobile('homeDiffuserImageAlt')}
            width={368}
            height={199}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <h3 className="subtitle">{tMobile('fragranceProd1')}</h3>
        </Link>
        <Link href={prodUrl('roomDiffuser')}>
          <img
            src="/statics/img/mobile/room-diffuser.webp"
            alt={tMobile('roomDiffuserImageAlt')}
            width={368}
            height={199}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <h3 className="subtitle">{tMobile('fragranceProd2')}</h3>
        </Link>
        <Link href={prodUrl('reedDiffuser')}>
          <img
            src="/statics/img/mobile/reed-diffuser.webp"
            alt={tMobile('reedDiffuserImageAlt')}
            width={368}
            height={199}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <h3 className="subtitle">{tMobile('fragranceProd3')}</h3>
        </Link>
        <Link href={prodUrl('candle')}>
          <img
            src="/statics/img/mobile/candle.webp"
            alt={tMobile('candleImageAlt')}
            width={368}
            height={199}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
          <h3 className="subtitle">{tMobile('fragranceProd4')}</h3>
        </Link>
      </div>
    </section>
  );
};

export default MobileBathFragranceSection;
